import {NgModule} from '@angular/core';
import {CommonModule, DatePipe, LowerCasePipe} from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {Routes, RouterModule} from '@angular/router';

import {IonicModule} from '@ionic/angular';

import {CheckoutComponent} from './containers/checkout/checkout.component';
import {PaymentComponent} from './components/payment/payment.component';
import {SharedModule} from '../../shared/shared.module';
import {TextMaskModule} from 'angular2-text-mask';
import {RouteService} from '../../core/services/route.service';
import {CookieService} from 'ngx-cookie-service';
import {CurrencyMaskModule} from 'ng2-currency-mask';
import {NgOtpInputModule} from 'ng-otp-input';
import {CountdownModule} from 'ngx-countdown';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { SavedCardComponent } from './components/payment/saved-card/saved-card.component';
import { URL } from '../../core/enums/url.enum';
import { ServiceItemComponent } from '../service-item/service-item.component';
import { MatSliderModule } from '@angular/material/slider';
import {ItemSuggestionsComponent} from './components/item-suggestions/item-suggestions.component';
import {MatIconModule} from "@angular/material/icon";
import {GiftCardsComponent} from './components/gift-cards/gift-cards.component';
import {IkonPassComponent} from './components/ikon-pass/ikon-pass.component';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';

const routes: Routes = [
  {
    path: '',
    component: CheckoutComponent
  },
  {
    path: URL.service_items,
    component: ServiceItemComponent
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SharedModule,
    TextMaskModule,
    CurrencyMaskModule,
    NgOtpInputModule,
    RouterModule.forChild(routes),
    CountdownModule,
    NgxIntlTelInputModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSliderModule,
    MatIconModule,
    MatTooltipModule,
    MatProgressSpinnerModule
  ],
  providers: [RouteService, CookieService, DatePipe, LowerCasePipe],
  declarations: [
    CheckoutComponent,
    PaymentComponent,
    SavedCardComponent,
    ServiceItemComponent,
    ItemSuggestionsComponent,
    GiftCardsComponent,
    IkonPassComponent
  ]
})
export class CheckoutPageModule {
}
